"use strict";
ui.loadTemplateFile("map.html");

import {
    minimapBoundsToWorld,
    minimapImagePath,
    worldToMapImage,
} from "../../js/maps/mapcoordinates";
import { NpcObject } from "../../js/objects/npcobject";

class MapDialog extends Dialog {
    _element: any;
    _currentZone: any;
    _zoneTable: any;
    _imageLoaded: boolean;
    _imageWidth: number;
    _imageHeight: number;
    _movementHandler: any;
    _objectHandler: any;

    constructor() {
        super("map.html");
        this._currentZone = null;
        this._zoneTable = null;
        this._imageLoaded = false;
        this._imageWidth = 0;
        this._imageHeight = 0;

        this._movementHandler = () => this._updateMap();
        this._objectHandler = () => {
            if (this._imageLoaded && MC && MC.zoneNo === this._currentZone) {
                this._updateMarkers(MC.zoneNo);
            }
        };

        GDM.get("list_zone", (zoneTable: any) => {
            this._zoneTable = zoneTable;
            this._updateMap();
        });

        if (MC) {
            MC.on("moved", this._movementHandler);
        }
        if (GZM.objects) {
            GZM.objects.on("object_added", this._objectHandler);
            GZM.objects.on("object_removed", this._objectHandler);
        }
    }

    _updateMap() {
        if (!this._zoneTable || !MC || MC.zoneNo === undefined) return;

        const mapId = MC.zoneNo;
        if (mapId === this._currentZone && this._imageLoaded) {
            this._updateMarkers(mapId);
            return;
        }

        const mapRow = this._mapRow(mapId);
        if (!mapRow) return;

        this._currentZone = mapId;
        this._imageLoaded = false;
        const imgElement = this._element.find("#map-image");
        const onImageLoad = () => {
            this._imageWidth = imgElement[0].naturalWidth;
            this._imageHeight = imgElement[0].naturalHeight;
            this._imageLoaded = true;

            const scale = Math.min(
                window.innerWidth * 0.7 / this._imageWidth,
                window.innerHeight * 0.7 / this._imageHeight
            );
            const displayWidth = this._imageWidth * scale;
            const displayHeight = this._imageHeight * scale;
            this._element.find(".map-content").css({
                width: displayWidth + "px",
                height: displayHeight + "px",
            });
            imgElement.css({
                width: displayWidth + "px",
                height: displayHeight + "px",
            });
            this._updateMarkers(mapId);
        };

        imgElement.off("load").on("load", onImageLoad);
        imgElement.attr("src", minimapImagePath(mapRow[8]));
        if (imgElement[0].complete && imgElement[0].naturalWidth > 0) {
            onImageLoad();
        }
    }

    _updateMarkers(mapId: any) {
        if (!this._imageLoaded) return;

        const mapRow = this._mapRow(mapId);
        if (!mapRow) return;

        const worldBounds = minimapBoundsToWorld(
            Number(mapRow[9]), Number(mapRow[10]), this._imageWidth, this._imageHeight
        );
        const mapContent = this._element.find(".map-content");
        const displayScaleX = mapContent.width() / this._imageWidth;
        const displayScaleY = mapContent.height() / this._imageHeight;
        const markersContainer = this._element.find("#map-markers").empty();
        const tooltip = this._element.find("#map-tooltip");

        const addMarker = (
            worldX: number,
            worldY: number,
            name: string,
            markerClass: string,
            radius: number
        ) => {
            const imagePoint = worldToMapImage(
                worldX,
                worldY,
                worldBounds,
                this._imageWidth,
                this._imageHeight
            );
            if (!imagePoint.inside) return;

            const marker = $("<div>")
                .addClass(`map-marker ${markerClass}`)
                .css({
                    left: imagePoint.x * displayScaleX - radius + "px",
                    top: imagePoint.y * displayScaleY - radius + "px",
                })
                .data("name", name);
            this._setupTooltip(marker, tooltip);
            markersContainer.append(marker);
        };

        if (MC && MC.position) {
            addMarker(MC.position.x, MC.position.y, MC.name || "You", "player-marker", 5);
        }

        if (GZM.objects && GZM.objects.objects) {
            GZM.objects.objects
                .filter((obj: any) => obj instanceof NpcObject)
                .forEach((npc: any) => {
                    if (npc.position) {
                        addMarker(
                            npc.position.x,
                            npc.position.y,
                            npc.name || `NPC #${npc.charIdx}`,
                            "npc-marker",
                            4
                        );
                    }
                });
        }
    }

    _mapRow(mapId: number) {
        const compiled = GZM.map?.compiledTerrain;
        if (compiled?.mapId === mapId && compiled.gameplay.settings.minimap) {
            const settings = compiled.gameplay.settings;
            const row: any[] = [];
            row[8] = settings.minimap;
            row[9] = settings.minimapStartX;
            row[10] = settings.minimapStartY;
            return row;
        }
        return this._zoneTable?.row(mapId);
    }

    _setupTooltip(marker: any, tooltip: any) {
        marker.on("mouseenter", function(e: any) {
            tooltip.text($(this).data("name")).css({
                display: "block",
                left: e.offsetX + 10 + "px",
                top: e.offsetY - 20 + "px",
            });
        });
        marker.on("mousemove", function(e: any) {
            const offset = $(this).closest(".map-content").offset();
            tooltip.css({
                left: e.pageX - offset.left + 10 + "px",
                top: e.pageY - offset.top - 20 + "px",
            });
        });
        marker.on("mouseleave", () => tooltip.hide());
    }

    close() {
        if (MC && this._movementHandler) {
            MC.removeEventListener("moved", this._movementHandler);
        }
        if (GZM.objects && this._objectHandler) {
            GZM.objects.removeEventListener("object_added", this._objectHandler);
            GZM.objects.removeEventListener("object_removed", this._objectHandler);
        }
        super.close();
    }
}

ui.MapDialog = MapDialog;
ui.mapDialog = function () {
    return new ui.MapDialog();
};
